/**
 *
 * @param {FormDataEvent} e
 * @param {handleTabSwitch} store
 * @returns {Promise<void>}
 */
async function handleSubmit(e, store) {
	e.preventDefault();
	const form = e.target;

	if (form.classList.contains('submitting')) {
		// console.log('form is already submitting');
		return;
	}

	const submit = form.querySelector('[type="submit"]');
	const currentSubmitText = submit.textContent;

	try {
		const isFormValid = validateForm(form, store);
		const currentTab = store.getCurrentTab();
		if (!isFormValid) {
			return;
		}

		if (isFormValid && !currentTab.isLast) {
			store.nextTab();
			return;
		}


		form.classList.add('submitting');
		submit.disabled = true;
		submit.textContent = 'Wysyłanie...';

		const discountInputs = form.querySelectorAll('input.input--discountfield');
		const checkDiscountCodes = await Promise.all(Array.from(discountInputs).map((input) => validateDiscountCode(input)));
		if (!checkDiscountCodes.every(Boolean)) {
			const [firstInvalidInput] = discountInputs;
			getFieldset(firstInvalidInput).scrollIntoView();
			firstInvalidInput.focus()
			return;
		}

		const token = await request_captcha('form_submission');
		const dataObject = getFormData(form, { token });

		const json = await fetch('/wp-json/contract-form/form-handler', {
			method: 'POST',
			body: JSON.stringify(dataObject),
			headers: {
				'Content-Type': 'application/json',
			}
		}).then((response) => response.json());

		// console.log('form success', json);
		const successPageUrl = form.dataset?.successPage ?? '';
		if (!json?.success) {
			throw new Error(json?.data?.[0]?.message || 'Coś poszło nie tak');
		}

		// remove from localstorage
		removePersistedForm(form.id);

		if (successPageUrl) {
			window.location.href = successPageUrl;
		}
	} catch (error) {
		console.error('form submission error', error.message);
		addError(form.querySelector('[type="submit"]'), 'Wystąpił błąd. Spróbuj ponownie później lub skontaktuj się z administratorem.');
	} finally {
		form.classList.remove('submitting');
		submit.textContent = currentSubmitText;
		submit.disabled = false;
	}


}
